import React from 'react';

// Shared pieces for the logo / number / name cards.
export const cardStyles = {
    addBtn: (enabled) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        width: '100%',
        padding: '9px 0',
        background: '#1a1a1a',
        border: '2px dashed #444',
        borderRadius: '6px',
        color: '#aaa',
        fontSize: '12px',
        cursor: enabled ? 'pointer' : 'not-allowed',
        opacity: enabled ? 1 : 0.35,
        boxSizing: 'border-box',
        outline: 'none',
    }),
    card: {
        background: '#1a1a1a',
        border: '1px solid #2a2a2a',
        borderRadius: '6px',
        padding: '10px 10px 12px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    cardHeader: { display: 'flex', alignItems: 'center', gap: '8px' },
    cardTitle: {
        flex: 1,
        fontSize: '11px',
        color: '#ccc',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    removeBtn: {
        all: 'unset',
        color: '#555',
        cursor: 'pointer',
        fontSize: '14px',
        lineHeight: 1,
        padding: '2px 4px',
        borderRadius: '3px',
        flexShrink: 0,
    },
    divider: { borderTop: '1px solid #2a2a2a' },
    hint: { fontSize: '10px', color: '#444', lineHeight: 1.5, margin: 0 },
};

/** Labelled range input. */
export function Slider({ label, value, min, max, step, format, onChange }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', color: '#666' }}>
                <span>{label}</span>
                <span style={{ color: '#999' }}>{format ? format(value) : value}</span>
            </div>
            <input
                type="range"
                min={min}
                max={max}
                step={step}
                value={value}
                style={{ width: '100%', cursor: 'pointer', accentColor: '#ecff19' }}
                onChange={(e) => onChange(Number(e.target.value))}
            />
        </div>
    );
}

/** X / Y / Scale / Rotate sliders shared by every placeable item. */
export function PlacementSliders({ item, scaleRange, onUpdate }) {
    return (
        <>
            <Slider label="X Position" value={item.x} min={0} max={1650} step={1}
                format={Math.round} onChange={(x) => onUpdate({ x })} />
            <Slider label="Y Position" value={item.y} min={0} max={1550} step={1}
                format={Math.round} onChange={(y) => onUpdate({ y })} />
            <Slider label="Scale" value={item.scale} min={scaleRange.min} max={scaleRange.max}
                step={scaleRange.step} format={(v) => `${v.toFixed(2)}×`}
                onChange={(scale) => onUpdate({ scale })} />
            <Slider label="Rotate" value={item.rotate} min={-180} max={180} step={1}
                format={(v) => `${Math.round(v)}°`} onChange={(rotate) => onUpdate({ rotate })} />
        </>
    );
}
